// Get Base Commission Rate
export const GET_BASE_COMMISSION_RATE_REQUEST = 'GET_BASE_COMMISSION_RATE_REQUEST';
export const GET_BASE_COMMISSION_RATE_DONE = 'GET_BASE_COMMISSION_RATE_DONE';
export const GET_BASE_COMMISSION_RATE_FAILED = 'GET_BASE_COMMISSION_RATE_FAILED';
